import { Component, Input, OnInit, OnDestroy, HostBinding, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import swal from 'sweetalert2';
import { BillingService } from '../../../services/billing.service';
import { getParamFromAncestorRoute, getQueryParamFromAncestorRoute } from '../../../utilities/route.utilities';


@Component({
    selector: 'cumulative-account-balance-grid-item',
    templateUrl: './cumulative-account-balance-grid-item.component.html',
})
export class CumulativeAccountBalanceGridItemComponent implements OnInit, OnDestroy {

    subscriptions: any[] = [];
    timePeriod: number = 1;
    clientId: number;
    siteId: number;
    accountBalance: any[] = [];
    hasData: boolean = false;
    hasLoading: boolean = true;

    constructor(
        private billingService: BillingService,
        private route: ActivatedRoute,
        private router: Router) {
        this.subscriptions.push(router.events.subscribe((event) => {

            if (event instanceof NavigationEnd) {
                this.ngOnInit();
            }
        }));
    }

    ngOnInit() {
        this.clientId = getParamFromAncestorRoute(this.route, 'clientId');
        this.timePeriod = getQueryParamFromAncestorRoute(this.route, 'timePeriod');
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    onInfoClick() {
        swal({
            title: 'Total portfolio account balance',
            html: '<p style="text-align: left;">This chart displays the total account balance across your portfolio.</p>\
              <p style="text-align: left;">It shows both debt and credit totals.</p>\
             <p style="text-align: left;">This indicates the overall behavior of your Billing portfolio consumers.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
